import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { listConveyor, unloadConveyorList } from "../../modules/conveyor/conveyorsSlice";
import PulleyList from "./PulleyList";
import { unloadConveyor } from "../../modules/conveyor/conveyorSlice";
import { useNavigate } from "react-router-dom";
import { initialize } from "../../modules/conveyor/conveyorWriteSlice";



const PulleyListContainer = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [ searchParams ] = useSearchParams();

    const user = useSelector(state => state.user.user);
    const project = useSelector(state => state.project.project);
    const conveyors = useSelector(state => state.conveyors.conveyors);
    const loading = useSelector(state => state.loading);
    const error = useSelector(state => state.conveyors.error);
    
    /* 뒤로가기 등을 쭉 하다보면 리덕스에서 project가 지워지는 상황 발생. 이때는 전체 컨베이어가 뜨는 문제 발생 */
    if (!project) {
        navigate(`/projects`);
    }


    /* 처음 로딩할 때 리덕스에서 conveyorWrite 지우기 <- Drive Pulley 수정을 위해서 PulleyEditorFromContainer 빠져나올 때 초기화 하지 않았기 때문 */
    useEffect(() => {
        dispatch(initialize());
    }, []);

    useEffect(() => {
        const tag = searchParams.get('tag');
        const page = parseInt(searchParams.get('page'), 10) || 1;
        const username = user ? user.username : null;
        const projectId = project?._id;

        dispatch(listConveyor({
            projectId,
            username,
            tag,
            page,
        }));

        // 여기서 다른 곳으로 갈 때(예를 들어 타워리스트 등으로) 컨베이어 리스트를 unload해줘야 함.
        return () => {
            dispatch(unloadConveyorList());
        }
    }, [dispatch, project?._id, searchParams, user]);

    const ownProject = (user && user._id) === (project && project.user._id);


    return (
        <PulleyList conveyors={conveyors} loading={!loading} error={error} project={project} ownProject={ownProject} />
    );

};

export default PulleyListContainer;

